module.exports = __webpack_public_path__ + "assets/img/10b.485d58f2.jpg";